<template>
  <div class="content-wrap">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8 p-0">
          <div class="page-header">
            <div class="page-title">
              <h1>Registro</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="row">
          <div class="col-lg-12">
            <div class="card alert">
              <div class="card-header">
                <h4>Crear nuevo usuario</h4>
                <div class="card-header-right-icon">
                  <ul>
                    <li class="card-close" data-dismiss="alert">
                      <i class="ti-close"></i>
                    </li>
                    <li class="doc-link">
                      <a ><i class="ti-link"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body">
                <div class="input-states">
                  <div class="form-horizontal">
                    <div class="form-group">
                      <div class="row">
                        <label class="col-sm-3 control-label">Tipo de usuario</label>
                        <div class="col-sm-9">
                          <select class="form-control test" v-model="selectedTypeUser" id="typeUser">
                            <option v-for="typeU in typeUser" v-bind:key="typeU">
                              {{ typeU }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <label class="col-sm-3 control-label">Nombre</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            placeholder="Nombre"
                            id="nombre"
                            class="form-control"
                            v-model="nombre"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <label class="col-sm-3 control-label">Apellidos</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            placeholder="Apellidos"
                            id="apellidos"
                            class="form-control"
                            v-model="apellidos"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <label class="col-sm-3 control-label">Correo</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            placeholder="Correo"
                            id="correo"
                            class="form-control"
                            v-model="correo"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <label class="col-sm-3 control-label">Contraseña</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            placeholder="Contraseña"
                            id="contrasena"
                            class="form-control"
                            v-model="contrasena"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-3"></div>
                        <div class="col-sm-9">
                          <button
                            class="btn btn-primary btn-flat"
                            v-on:click="onSignup"
                          >
                            Crear Usuario
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /# column -->
        </div>
        <!-- /# row -->
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  data() {
    return {
      correo: "",
      contrasena: "",
      nombre: "",
      apellidos: "",
      typeUser: [],
      selectedTypeUser: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  mounted(){
    this.changeTypeUsers()
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.correo = "";
        this.contrasena = "";
        this.nombre = "";
        this.apellidos = "";
      }
    }
  },
  methods: {
    onSignup: function() {
      this.$store.dispatch("singUserUp", {
        correo: this.correo,
        contrasena: this.contrasena,
        firstName: this.nombre,
        lastName: this.apellidos,
        selectedTypeUser: this.selectedTypeUser
      });
    },

    changeTypeUsers: function() {
        firebase.auth().onAuthStateChanged((user) =>{
          if(user){
           let userType = user.displayName.split("/")[0];
           if(userType == "0"){
              this.typeUser = ["4bits","Administrador"]
            }
            else{
              this.typeUser = ["Cocina","Mesero"]
            }
          }
        })
    }
  }
};
</script>
